module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img71.3102b2cc.jpg";